export default "__VITE_ASSET__A4vkDGoR__"